import { render, staticRenderFns } from "./input-search.vue?vue&type=template&id=3cdb0e52&"
import script from "./input-search.vue?vue&type=script&lang=ts&"
export * from "./input-search.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports